import React from 'react'
import { Trans } from '@lingui/macro'

import { Box, ButtonPrimary, Flex } from 'front-end/src/components'
import { TopicElementModelAsEditor } from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { DangerouslySetInnerHTML } from 'front-end/src/utils/DangerouslySetInnerHTML'
import IconFile from 'front-end/src/components/common/icon/IconFile'
import { brandColors } from 'shared/basicPalette'

import './DocumentElement.less'

export const DocumentElement = (
  props: TopicElementModelAsEditor['data'] & { hideButton?: boolean }
) => {
  const { content, fileDetails, hideButton } = props

  const fileUrl = fileDetails && fileDetails.fileUrl
  const fileSize = fileDetails && fileDetails.fileSize
  const cdnUrl = fileDetails && fileDetails.cdnUrl
  const downloadDocumentFilename = fileUrl && fileUrl.split('/').pop()
  const downloadDocumentExtension = fileUrl && fileUrl.split('.').pop()

  const humanFileSize = `${fileSize}Kb`
  const description = <DangerouslySetInnerHTML content={content as string} />

  return (
    <Flex
      className="element-file"
      direction="column"
      border={`1px solid ${brandColors.grey[200]}`}
      borderRadius="4px"
      p={hideButton ? '0 24px 24px' : '24px'}
    >
      {description && <Box>{description}</Box>}
      <Flex>
        {cdnUrl && downloadDocumentExtension && (
          <Flex
            grow={1}
            color={brandColors.grey[500]}
            wordWrap="break-word"
            wordBreak="break-all"
            whiteSpace="pre-wrap"
          >
            <IconFile fileExtension={downloadDocumentExtension} mr="4px" />
            <Flex alignItems="center" fontSize="12px">
              {downloadDocumentFilename}
              <br />
              {humanFileSize}
            </Flex>
          </Flex>
        )}
        {cdnUrl && !hideButton && (
          <ButtonPrimary
            key={1}
            onClick={() => {
              window.location.assign(cdnUrl)
            }}
          >
            <Trans>Open this file</Trans>
          </ButtonPrimary>
        )}
      </Flex>
    </Flex>
  )
}
